/**
 * @namespace {BX.UI}
 */
export default class SplitSubButtonType
{
	static MAIN = 'ui-btn-main';
	static MENU = 'ui-btn-menu';
	static SWITCHER = 'ui-btn-switcher';
}
